import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { uk } from 'date-fns/locale';

interface DateNavigatorProps {
  date: string; // 'YYYY-MM-DD'
  onDateChange: (date: string) => void;
}

export const DateNavigator: React.FC<DateNavigatorProps> = ({ date, onDateChange }) => {
  const [pickerOpen, setPickerOpen] = React.useState(false);

  const toLocalDateStr = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  const shiftDate = (days: number) => {
    const d = new Date(date + 'T12:00:00');
    d.setDate(d.getDate() + days);
    onDateChange(toLocalDateStr(d));
  };

  const formatted = new Date(date + 'T12:00:00').toLocaleDateString('uk-UA', {
    weekday: 'long', day: 'numeric', month: 'long',
  });

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5 }}>
        <IconButton size="small" onClick={() => shiftDate(-1)}>
          <ArrowBackIos fontSize="small" />
        </IconButton>
        <Typography
          variant="subtitle1"
          onClick={() => setPickerOpen(true)}
          sx={{ fontWeight: 600, minWidth: 220, textAlign: 'center', textTransform: 'capitalize', cursor: 'pointer', '&:hover': { color: 'primary.main' } }}
        >
          {formatted}
        </Typography>
        <IconButton size="small" onClick={() => shiftDate(1)}>
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      </Box>

      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={uk}>
        <MobileDatePicker
          value={new Date(date + 'T12:00:00')}
          onChange={(val) => { if (val) onDateChange(toLocalDateStr(val)); }}
          open={pickerOpen}
          onOpen={() => setPickerOpen(true)}
          onClose={() => setPickerOpen(false)}
          slotProps={{
            actionBar: { actions: ['today', 'cancel', 'accept'] },
            textField: { sx: { display: 'none' } },
          }}
        />
      </LocalizationProvider>
    </>
  );
};
